/* unplugin-vue-components disabled */import { render } from "./symbol-counter.vue?vue&type=template&id=0ef37177&scoped=true"
import script from "./symbol-counter.vue?vue&type=script&lang=js"
export * from "./symbol-counter.vue?vue&type=script&lang=js"

import "./symbol-counter.vue?vue&type=style&index=0&id=0ef37177&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef37177"],['__file',"src/controls/symbol-counter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ef37177"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ef37177', __exports__)) {
    api.reload('0ef37177', __exports__)
  }
  
  module.hot.accept("./symbol-counter.vue?vue&type=template&id=0ef37177&scoped=true", () => {
    api.rerender('0ef37177', render)
  })

}


export default __exports__